<template>
  <div
    v-if="showAds"
    class="grey lighten-3"
    style="width:100%; min-height:90px;"
  >
    <div :id="adUnitDivId"></div>
  </div>
</template>

<script>
import store from '../../store'

const AD_UNIT_DIV_ID = 'div-gpt-ad-1784467955759-0'
const AD_SIZES = [[728, 90], [970, 90], [320, 50], [300, 50]]

export default {
  name: 'AdBanner',

  data: () => ({
    adUnitPath: process.env.VUE_APP_GAM_AD_UNIT_PATH,
    adUnitDivId: AD_UNIT_DIV_ID,
    slot: null
  }),

  computed: {
    isPro() {
      return !!(store.state.subscription && store.state.subscription.is_pro)
    },
    showAds() {
      return store.state.isAuthenticated && !this.isPro && !!this.adUnitPath
    }
  },

  watch: {
    showAds(newValue) {
      if (newValue) {
        this.$nextTick(this.displaySlot)
      } else {
        this.destroySlot()
      }
    }
  },

  mounted() {
    window.googletag = window.googletag || { cmd: [] }
    this.loadScript()
    if (this.showAds) {
      this.$nextTick(this.displaySlot)
    }
  },

  beforeDestroy() {
    this.destroySlot()
  },

  methods: {
    loadScript() {
      if (document.getElementById('gpt-script')) {
        return
      }
      const script = document.createElement('script')
      script.id = 'gpt-script'
      script.async = true
      script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
      document.head.appendChild(script)
    },
    displaySlot() {
      if (this.slot || !this.adUnitPath) {
        return
      }
      window.googletag.cmd.push(() => {
        const sizeMapping = window.googletag.sizeMapping()
          .addSize([768, 0], [[728, 90], [970, 90]])
          .addSize([0, 0], [[320, 50], [300, 50]])
          .build()

        this.slot = window.googletag
          .defineSlot(this.adUnitPath, AD_SIZES, this.adUnitDivId)
          .defineSizeMapping(sizeMapping)
          .addService(window.googletag.pubads())

        if (!window.__gamServicesEnabled) {
          window.googletag.pubads().enableSingleRequest()
          window.googletag.pubads().collapseEmptyDivs()
          window.googletag.enableServices()
          window.__gamServicesEnabled = true
        }

        window.googletag.display(this.adUnitDivId)
      })
    },
    destroySlot() {
      if (!this.slot) {
        return
      }
      const slot = this.slot
      this.slot = null
      window.googletag.cmd.push(() => {
        window.googletag.destroySlots([slot])
      })
    }
  }
}
</script>
